import AnnouncementModal from './AnnouncementModal'

export default AnnouncementModal
